<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
      <tr>
        <th class='text-center py-4' v-for='key of keys' :key='key'>{{ key.toUpperCase() }}</th>
      </tr>
      </thead>
      <tbody>
      <tr
          v-for='(el,index) in additionalFiles'
          :key='index'
      >
        <td style='width: 5%'>{{ index + 1 }}</td>
        <td style='width: 25%'>
          <v-text-field
              v-model='additionalFiles[index].Name'
              :disabled='!input.isEdit'
              class='mt-6'
              label='Названия'
              outlined
              dense
          />
        </td>
        <td style='width: 25%'>
          <v-text-field
              v-model='additionalFiles[index].Comment'
              :disabled='!input.isEdit'
              class='mt-6'
              label='Комментарий'
              outlined
              dense
          />
        </td>
        <td style='width: 20%' class='pt-6'>

          <oil-date-picker
              :item='el'
              item-key='StartDate'
              :v-input='input'
              :keys='startDateKeys'
              :attr='startDateKeys.attrs'
          />
        </td>
        <td style='width: 20%'>
          <Test
              :contract='con'
              :item='el'
              :input='input'
          ></Test>
        </td>
        <td class='text-center' style='width: 5%'>
          <v-btn color='green' icon :disabled='!input.isEdit || !el.Attachment'
                 @click='dow(el)'
          >
            <v-icon
                color='green'>mdi-download
            </v-icon>
          </v-btn>
        </td>
        <td class='text-center' style='width: 5%'>
          <template>
            <v-row justify='center'>
              <v-dialog
                  v-model='dialog'
                  persistent
                  max-width='300'
              >
                <template v-slot:activator='{ on, attrs }'>
                  <v-btn
                      color='red'
                      dark
                      v-bind='attrs'
                      v-on='on'
                      icon
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <v-card class='pt-4'>
                  <v-card-text>Вы точно хотите удалить этот документ?</v-card-text>
                  <v-card-actions>
                    <v-btn
                        color='green darken-1'
                        text
                        @click='remove(index,el)'
                    >
                      Подтвердить
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        color='green darken-1'
                        text
                        @click='dialog = false'
                    >
                      Отменить
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import Test from '~/pages/contract/setting/Test'
import { fileService } from '~/services/FileNextNumberService'
import { coreApi } from '~/services/core'

export default {
  components: {
    Test,
    OilDatePicker: () => import('@/components/helper/form/oil.date.picker')
  },
  props: {
    con: Object,
    item: Object,
    input: Object
  },
  data() {
    return {
      dialog: false,
      keys: [
        '#', 'Названия', 'Комментарии', 'Дата', 'ФАЙЛ', 'Скачать', 'Удалить'
      ],
      startDateKeys: {
        attrs: {
          readonly: false,
          outlined: true,
          dense: true,
          label: 'Дата начало'
        }
      }
    }
  },
  created() {
    this.item.AdditionalFiles ??= []
  },
  computed: {
    additionalFiles() {
      return this.item.AdditionalFiles
    }
  },
  methods: {
    async remove(index, el) {
      const data = this.con
      if (el.Attachment) {
        await coreApi.delete(`file/${el.Attachment.Id}`)
      }
      this.item.AdditionalFiles.splice(index, 1)
      await coreApi.put('contract', data)

      this.dialog = false
    }
  }

}
</script>
<style>
.tbody:hover {
  background-color: darkslategray !important;
}

.date:hover {
  cursor: pointer !important;
  overflow-x: hidden !important;
}
</style>

